import { render, staticRenderFns } from "./SubstractForm.vue?vue&type=template&id=bb61a0c4&"
import script from "./SubstractForm.vue?vue&type=script&lang=ts&"
export * from "./SubstractForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports